{
  "decrease": "Minska {fieldLabel}",
  "increase": "Öka {fieldLabel}",
  "numberField": "Nummerfält"
}
